// Typelizer digest b462f75283ae35801ef91ac30c7901a9
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/overview/month_end_auto_match */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/overview/month_end_auto_match', {}, options),
    method: 'post',
  }),
}
